import { Component, EventEmitter, OnInit, Output, TemplateRef } from '@angular/core';

import * as screenfull from 'screenfull';
import { AuthService } from '../../auth/auth.service';
import { Router } from '@angular/router';
import { SidebarService } from '../../main/common/menu/service/sidebar.service';
import { MenuItem } from 'primeng/api';
import { UiService } from '../../shared/services/ui.service';
import { StorageConst } from '../../shared/consts/storage-consts';
import { RoutesUrl } from '../../shared/consts/routes';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from '../../shared/custom-components/base-component/base-component.component';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { DialogService } from 'src/app/shared/services/dialog-service';
import { MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { User } from '../../shared/models/user.model';
import { MatAutocompleteActivatedEvent } from '@angular/material/autocomplete';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html'
})
export class HeaderComponent extends BaseComponent implements OnInit {

  constructor(
    private router: Router,
    private authService: AuthService,
    private sidebarService: SidebarService,
    private translate: TranslateService,
    private dialog: DialogService,
    private uiService: UiService) {
    super();
  }

  @BlockUI('header') blockUI: NgBlockUI;


  @Output() toggleSidenav = new EventEmitter<void>();
  @Output() toggleNotificationSidenav = new EventEmitter<void>();
  searchText: string;
  searchGCount: number;
  searchLCount: number;
  menuItems: MenuItem[];
  menuItems2: MenuItem[]
  menuItems3: MenuItem[];
  areYouSureDialogRef: MatDialogRef<any>;
  navigateCRMDaialogRef: MatDialogRef<any>;
  autoCompleateReport: any;
  menuTreeItems: MenuItem[];
  autoCompleateResults: MenuItem[];
  autoCompleateResultsForRouterLinks: MenuItem[];
  allItemsFlated: MenuItem[] = [];
  currentUser: User;

  autoLogin$: Observable<boolean>

  isBreak = false;

  fullScreenToggle(): void {
    if (screenfull.isEnabled) {
      screenfull.toggle();
    }
  }

  ngOnInit() {
    this.autoLogin$ = this.uiService.autoLogin$;
    this.sidebarService.menuTreeItemsChanges.pipe(filter(items => !!items.length)).subscribe(result => {
      this.getAllItems(result);
      this.menuTreeItems = result;

      if (this.menuTreeItems.length === 1 && this.menuTreeItems[0]?.routerLink) { // only one item in the menu tree
        // debugger
        this.router.navigate([this.menuTreeItems[0].routerLink], {queryParamsHandling: 'merge'})
      }

      this.setCurrentUser();
    });
  }

  openNavigateCRMDDialog(navigateCRMDaialog: TemplateRef<any>) {
    this.navigateCRMDaialogRef = this.dialog.open(navigateCRMDaialog);
  }

  navigateCRM() {
    // On login Admin doesn't save 'defaultPosId' or 'POS_ID' to local storage
    // const posId = sessionStorage.getItem('defaultPosId');
    const accessCode = sessionStorage.getItem('ACCESS_CODE');
    const adminToken = sessionStorage.getItem('TOKEN');
    const crmURL = `${environment.posURL}/crm/main/search?posId=101&accessCode=${accessCode}&isRedirectedFromPOS=true&adminToken=${adminToken}`;

    window.location.href = crmURL;
    this.navigateCRMDaialogRef.close();
  }

  logoutButtonTapHandler(areYouSureTmpl: TemplateRef<any>): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    this.areYouSureDialogRef = this.dialog.open(areYouSureTmpl, dialogConfig);
  }

  logoutButtonTap() {
    this.authService.logout().then(result => {
      this.uiService.resetDirectionOnBody();
      this.biggerPictureMessagesService.reset();
      sessionStorage.removeItem(StorageConst.TOKEN);
      sessionStorage.removeItem(StorageConst.USER);
      const accessCode: string = sessionStorage.getItem("ACCESS_CODE");
      window.location.href = accessCode ?
        `${RoutesUrl.session.signIn}?accessCode=${accessCode}`
        :
        RoutesUrl.session.signIn;
    }).catch(err => {
      console.error('Failed to log out');
    });
  }

  onMenuItemClick(option: MenuItem): void {
    setTimeout(() => {
      this.toggleSearch();
    }, 0);
  }

  clearCache() {
    this.blockUI.start(this.translate.instant(this.tranKey(this.moi.SYSTEM, this.systemMessagesEnum.LoadingData)));
    this.uiService.clearCache()
      .then(result => {
        Swal.fire({
          title: this.translate.instant(this.tranKey(this.moi.SYSTEM, this.systemMessagesEnum.OperationSuccessfullyCompleted)),
          icon: 'success',
          showCloseButton: true,
          allowOutsideClick: false,
        });
      }).catch(err => {
      const firstErr = Array.isArray(err) ? err[0] : err;
      const innerError = firstErr?.error?.error;
      const isTooManyRequests = innerError?.returnCode === 10033 || innerError?.name === 'TooManyRequests';
      Swal.fire({
        title: isTooManyRequests
          ? this.translate.instant(this.tranKey(this.moi.SYSTEM, this.systemMessagesEnum.ClearCacheTooManyRequests))
          : this.translate.instant(this.tranKey(this.moi.SYSTEM, this.systemMessagesEnum.OperationFailed)),
        icon: isTooManyRequests ? 'warning' : 'error',
        showCloseButton: true,
        allowOutsideClick: false,
      });
    }).finally(() => this.blockUI.stop());
  }

  setCurrentUser() {
    this.currentUser = JSON.parse(sessionStorage.getItem(StorageConst.USER));
  }

  toggleSearch(allowedNavigation: boolean = false) {

    if (this.searchText.length > 0) {

      const keySearchText = 'searchText';
      const searchTextStorage = sessionStorage.getItem(keySearchText);

      const keyCount = 'searchCount';
      let sCount = '1';
      if (searchTextStorage === this.searchText) {
        const searchCount = sessionStorage.getItem(keyCount);
        if (searchCount == null || searchCount === 'undefined') {
          sCount = '1';
        } else {
          this.searchGCount = parseInt(searchCount, 0);
          this.searchGCount = this.searchGCount + 1;
          const sCount = '' + this.searchGCount;
        }
        sessionStorage.setItem(keyCount, sCount);
      } else {
        sessionStorage.setItem(keySearchText, this.searchText);
        sessionStorage.setItem(keyCount, '1');
        this.searchGCount = 1;
      }

      this.isBreak = false;
      this.searchLCount = 1;
      this.clearMenuTree(this.menuTreeItems, this.searchText);
      this.findMenuTree(this.menuTreeItems, this.searchText, allowedNavigation);
      if (!this.isBreak) {
        sessionStorage.setItem('searchCount', '0');
      }


    }
  }

  onSearchChanged(term): void {
    this.searchText = term;
    setTimeout(() => {
      this.findMenuTree(this.menuTreeItems, this.searchText);
    }, 0);

  }

  onOptionActivate(option: MatAutocompleteActivatedEvent) {
    setTimeout(() => {
      this.clearMenuTree(this.menuTreeItems, this.searchText);
      this.findMenuTree(this.menuTreeItems, option.option.value);
    }, 0);
  }

  toggleAutoComplete(): void {
    this.findMenuTreeForAutoCompleate(this.searchText ?? '');
  }

  findMenuTreeForAutoCompleate(search: string) {
    const normalizedSearch = search.toLowerCase().trim();
    const tokens = normalizedSearch.split(/\s+/); // split the search text into tokens based on whitespace

    const matchesPartial = (text?: string): boolean => {
      if (!text) return false;
      const normalizedText = text.toLowerCase();

      return tokens.every(token => normalizedText.includes(token));
    };

    const filteredItems: MenuItem[] = this.allItemsFlated.filter(item => {
      if (!item?.routerLink) return false;

      const labelMatch = matchesPartial(item.label);
      const routerMatch = matchesPartial(item.routerLink);
      const automationMatch = matchesPartial(item.automationId?.toString());

      return labelMatch || routerMatch || automationMatch;
    });

    this.autoCompleateResults = filteredItems;
  }

  getAllItems(result: MenuItem[]): void {
    for (const value of result) {
      if (value?.routerLink) {
        this.allItemsFlated.push(value);
      } else if (value?.items) {
        this.getAllItems(value.items);
      }
    }
  }

  onSelectionChanged(option): void {
    const AllowedNavigation = true;
    this.toggleSearch(AllowedNavigation);
  }


  findMenuTree(result: MenuItem[], search: string, allowedNavigation: boolean = false) {
    this.isBreak = false;
    for (const value of result) {
      if (!this.isBreak) {

        const menuItems: any = value;
        if (typeof (menuItems.items) !== 'undefined') {
          if (typeof (menuItems.routerLink) === 'undefined') {
            this.findMenuTree(menuItems.items, search, allowedNavigation);

            if (this.isBreak) {
              menuItems.expanded = true;
            }
          }
        } else {

          if (menuItems.label?.toLowerCase().indexOf(search.toLowerCase()) > -1 ||
            menuItems.routerLink?.toLowerCase().indexOf(search.toLowerCase()) > -1) {

            if (menuItems.label === search) {
              this.isBreak = true;
              // menuItems.id = '10000';
              menuItems.styleClass = 'TITAN-ui-menuitem-text';
              if (allowedNavigation) {
                this.router.navigate([menuItems.routerLink]);
              }
              break;
            } else {
              this.searchLCount++;
            }
          }
        }
      }
    }
  }

  clearMenuTree(result: MenuItem[], search: string) {
    for (const value of result) {
      const menuItems: any = value;
      if (typeof (menuItems.items) !== 'undefined') {
        if (typeof (menuItems.routerLink) === 'undefined') {
          this.clearMenuTree(menuItems.items, search);
          menuItems.expanded = false;
          menuItems.styleClass = '';
        }
      } else {
        menuItems.expanded = false;
        menuItems.styleClass = '';
      }
    }
  }

  goToHomepage() {
    this.router.navigate(['home']);
  }
}
